import React, { useRef, useState } from "react";
import { useRestApi } from "../hooks";
import { useWorkplanQuery } from "../graphql/query";
import { WorkplanExportPreviewModal } from "@design-system";

type Props = {
  matterId: number;
  onClose: () => void;
};

export const WorkplanPreviewContainer = ({ matterId, onClose }: Props) => {
  const downloadRef = useRef<HTMLAnchorElement | null>(null);
  const { loading, data } = useWorkplanQuery(matterId);
  const workplan = data?.generateWorkplan;

  const [downloading, setDownloading] = useState(false);
  const restApi = useRestApi();
  const onDownload = async () => {
    setDownloading(true);
    try {
      const fileDownloader = await restApi.getWorkplanSpreadsheet(matterId);
      if (downloadRef.current) {
        await fileDownloader.download(downloadRef.current);
      }
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <WorkplanExportPreviewModal
        show={true}
        loading={loading}
        workplan={workplan}
        onCancel={onClose}
        downloading={downloading}
        onDownload={onDownload}
      />
      <a ref={(e) => { downloadRef.current = e; }} />
    </>
  );
};
